export const nullCheckImage = (image) => {
	return image !== null && image !== undefined ? image.url : null;
};
